/* tslint:disable */
/* eslint-disable */
/**
 * Riders API
 * Internal Riders TV API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRiderTabs200ResponseTabsInnerStatus } from './GetRiderTabs200ResponseTabsInnerStatus';
import {
    GetRiderTabs200ResponseTabsInnerStatusFromJSON,
    GetRiderTabs200ResponseTabsInnerStatusFromJSONTyped,
    GetRiderTabs200ResponseTabsInnerStatusToJSON,
    GetRiderTabs200ResponseTabsInnerStatusToJSONTyped,
} from './GetRiderTabs200ResponseTabsInnerStatus';

/**
 * 
 * @export
 * @interface GetRiderTabs200ResponseTabsInner
 */
export interface GetRiderTabs200ResponseTabsInner {
    /**
     * 
     * @type {string}
     * @memberof GetRiderTabs200ResponseTabsInner
     */
    tabId: string;
    /**
     * 
     * @type {string}
     * @memberof GetRiderTabs200ResponseTabsInner
     */
    code: string;
    /**
     * 
     * @type {GetRiderTabs200ResponseTabsInnerStatus}
     * @memberof GetRiderTabs200ResponseTabsInner
     */
    status?: GetRiderTabs200ResponseTabsInnerStatus;
}

/**
 * Check if a given object implements the GetRiderTabs200ResponseTabsInner interface.
 */
export function instanceOfGetRiderTabs200ResponseTabsInner(value: object): value is GetRiderTabs200ResponseTabsInner {
    if (!('tabId' in value) || value['tabId'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function GetRiderTabs200ResponseTabsInnerFromJSON(json: any): GetRiderTabs200ResponseTabsInner {
    return GetRiderTabs200ResponseTabsInnerFromJSONTyped(json, false);
}

export function GetRiderTabs200ResponseTabsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRiderTabs200ResponseTabsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'tabId': json['tabId'],
        'code': json['code'],
        'status': json['status'] == null ? undefined : GetRiderTabs200ResponseTabsInnerStatusFromJSON(json['status']),
    };
}

export function GetRiderTabs200ResponseTabsInnerToJSON(json: any): GetRiderTabs200ResponseTabsInner {
    return GetRiderTabs200ResponseTabsInnerToJSONTyped(json, false);
}

export function GetRiderTabs200ResponseTabsInnerToJSONTyped(value?: GetRiderTabs200ResponseTabsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tabId': value['tabId'],
        'code': value['code'],
        'status': GetRiderTabs200ResponseTabsInnerStatusToJSON(value['status']),
    };
}

